import { render, staticRenderFns } from "./appManage.vue?vue&type=template&id=3d20866c&scoped=true"
import script from "./appManage.vue?vue&type=script&lang=js"
export * from "./appManage.vue?vue&type=script&lang=js"
import style0 from "./appManage.vue?vue&type=style&index=0&id=3d20866c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d20866c",
  null
  
)

export default component.exports